import React from 'react'
import { useTranslation } from 'react-i18next'
import './TournamentGroupPhoto.css'

/**
 * Single full-width group photo after the Instagram videos section.
 * Max width matches TournamentInstagramVideos container (1200px) minus 15% = 1020px.
 * Optimized JPEG at public/img/tournament-group.jpg.
 */
const TournamentGroupPhoto: React.FC = () => {
    const { t } = useTranslation()

    return (
        <section className="tournament-group-photo-section">
            <div className="tournament-group-photo-wrapper">
                <img
                    src="/img/tournament-group.jpg"
                    alt={t('tournaments.groupPhoto.alt')}
                    className="tournament-group-photo"
                    loading="lazy"
                    decoding="async"
                />
            </div>
        </section>
    )
}

export default TournamentGroupPhoto
